import axios from 'axios';
import { API_URL } from '../../config/url_envoiriment';


export const api_pdf = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Se precisar enviar cookies para o backend
  mode: "cors", // Importante para habilitar CORS
});

export const generateConsultationPdf = async (consultation, patient, dietData, anthropometryData) => {
  const getTokenFromCookie = () => {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'token') return value;
    }
    return null;
  };

  const token = getTokenFromCookie();

  const response = await api_pdf.post(
    '/pdf_generator/pdf/generate/consult',
    { consultation, patient, dietData, anthropometryData },
    {
      headers: {
        Authorization: `Bearer ${token}`
      },
      responseType: 'blob',
      withCredentials: true
    }
  );

  return new Blob([response.data], { type: 'application/pdf' });
};


export const printPdf = async (currentConsultation, person, dietData, anthropometryData) => {
  try {
    const getTokenFromCookie = () => {
      const cookies = document.cookie.split(';');
      for (const cookie of cookies) {
        const [name, value] = cookie.trim().split('=');
        if (name === 'token') return value;
      }
      return null;
    };

    const token = getTokenFromCookie();

    const response = await api_pdf.post(
      '/pdf_generator/pdf/generate/consult',
      {
        consultation: currentConsultation,
        patient: person,
        dietData,
        anthropometryData,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
        withCredentials: true,
      }
    );

    // 📦 Verifica se o conteúdo é um PDF
    if (!response.data || response.data.type !== 'application/pdf') {
      const text = await response.data.text?.();
      console.error('❌ Backend retornou erro no PDF:', text);
      alert('Erro ao gerar o PDF da consulta.');
      return;
    }

    // 🏷️ Extrai o nome do arquivo dos headers (se disponível)
    const contentDisposition = response.headers['content-disposition'];
    // console.log(response.headers)
    let filename = 'Consulta.pdf';
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match && match[1]) {
        filename = match[1];
      }
    }

    // 💾 Cria o Blob e baixa o arquivo
    const url = URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

  } catch (err) {
    console.error('🚨 Erro ao gerar PDF:', err.response?.data || err.message);
    alert('Erro ao gerar o PDF da consulta.');
  }
};
